import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Graph from './Graph'
import { InformationIcon } from '../../../../icons'
import PageModal from '../../../common/PageModal'
import GenericTable from '../../../common/GenericTable'
import LoadingSpinner from '../../../common/LoadingSpinner'
import EmptyPageResults from '../../../common/EmptyPageResults'
import { toast } from '../../../common/Toast'
import { getAnalyticsFaultsCycleDetailsMonthly, getAnalyticsFaultsCycleDetailsDaily } from '../../../../utils/requests/cyclesAPI'
import './analytics-details-modal.scss'

const AnalyticsDetailsModal = (props) => {
  const { t } = useTranslation()
  const { selectedProduct, cf, model, description, duration, isSerialNumberSearch, closeModal } = props
  const [showSpinner, setShowSpinner] = useState(null)
  const [cycleDetailsTableData, setCycleDetailsTableData] = useState([])
  const [isFirstLoad, setIsFirstLoad] = useState(true)

  const useDaily = duration === 30
  const apiFn = useDaily ? getAnalyticsFaultsCycleDetailsDaily : getAnalyticsFaultsCycleDetailsMonthly
  const durationParam = useDaily ? 30 : 6
  const firstColTitle = useDaily ? t('date') : t('month')

  const formatPeriod = (entry) => {
    if (useDaily) {
      return entry.date
    }

    return `${entry.year}-${entry.month.toString().padStart(2, '0')}`
  }

  useEffect(() => {
    setShowSpinner(true)
    let queryParams = {
      cycle_fault: cf,
      duration: durationParam,
    }

    if (isSerialNumberSearch) {
      queryParams = { ...queryParams, sn: selectedProduct }
    } else {
      queryParams = { ...queryParams, product_type: selectedProduct }
    }

    apiFn(queryParams)
      .then((response) => {
        const cycleDetailsData = response.data
        const tableData = []

        const normalizedModel = (v) => (v == null ? '' : String(v).trim().toUpperCase())
        const targetModel = normalizedModel(model)
        const filtered = targetModel
          ? cycleDetailsData.filter((entry) => {
              const m = normalizedModel(entry.model)
              return m === targetModel
            })
          : cycleDetailsData

        filtered.forEach((model) => {
          model.trend.forEach((trendItem) => {
            tableData.push({
              date: formatPeriod(trendItem),
              model: model.model,
              month: trendItem.month,
              year: trendItem.year,
              total_faults: trendItem.total_faults,
              unique_sn: trendItem.unique_sn,
            })
          })
        })
        setCycleDetailsTableData(tableData)

        setShowSpinner(false)
        setIsFirstLoad(false)
      })
      .catch(() => {
        toast.error(t('error.something_wrong'))

        setShowSpinner(false)
        setIsFirstLoad(false)
      })
  }, [])

  const handleCloseModal = () => {
    if (closeModal) {
      closeModal()
    }
  }

  return (
    <div className="analytics-details-wrapper">
      <PageModal toggle onToggle={() => handleCloseModal()} title={t('monitoring.cycle-details')}>
        <div className="analytics-details-content">
          {cycleDetailsTableData.length > 0 && (
            <>
              <div className="model-title">
                {model} (CF: {cf})
              </div>
              {description?.length > 0 && (
                <div className="disclaimer-box-text">
                  <div className="icon-wrapper">
                    <InformationIcon />
                    <div className="title">{t('reports.cf_description')}</div>
                  </div>
                  <ul className="disclaimer-wrapper">
                    {description.map((el, index) => (
                      <span key={index}>
                        {el.split('\\n').map((desc, subIndex) => (
                          <li key={subIndex} className="cycle-description">
                            {desc}
                          </li>
                        ))}
                      </span>
                    ))}
                  </ul>
                </div>
              )}
              <div className="graph-wrapper">
                <Graph data={cycleDetailsTableData} />
              </div>
              <GenericTable
                id="cycle-details-table"
                className="cycle-details-table"
                data={cycleDetailsTableData}
                headers={[
                  {
                    title: firstColTitle,
                  },
                  {
                    title: t('monitoring.total_cf'),
                  },
                  {
                    title: t('monitoring.unique_sn_cf'),
                  },
                ]}
                keys={['date', 'total_faults', 'unique_sn']}
                keyRenderer={{
                  code: (item) => {
                    return <div className={`product-type-wrapper`}>{item.code}</div>
                  },
                }}
              />
            </>
          )}
          {cycleDetailsTableData.length === 0 && !isFirstLoad && (
            <div className="no-product-wrapper">
              <EmptyPageResults title={t('tracking.no_data')} />
            </div>
          )}
        </div>
      </PageModal>
      {showSpinner && (
        <div className="spinner-wrapper">
          <LoadingSpinner />
        </div>
      )}
    </div>
  )
}

export default AnalyticsDetailsModal

